module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-info-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('b', [_vm._v(_vm._s(_vm.item.code))]), _vm._v(" от " + _vm._s(_vm.formats.blank(_vm.item.date, _vm.formats.formatDate)) + "\n          ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n           Номер: "), _c('b', [_vm._v(_vm._s(_vm.item.grnip))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n            " + _vm._s(_vm.item.name) + "\n          ")]), _vm._v(" "), _c('v-flex', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.date, _vm.formats.formatDate)))]), _vm._v(" - " + _vm._s(_vm.formats.blank(_vm.formats.getValue(_vm.item, ['tax', 'name']))) + " (" + _vm._s(_vm.formats.blank(_vm.formats.getValue(_vm.item, ['tax', 'code']))) + ") \n          ")]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.documents != null),
      expression: "item.documents != null"
    }]
  }, [_vm._v("\n            Документы:\n            "), _vm._l((_vm.item.documents), function(doc) {
    return [_c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.formats.getValue(doc, ['date']), _vm.formats.formatDate)))]), _vm._v(" - " + _vm._s(_vm.formats.blank(_vm.formats.getValue(doc, ['name']))) + " (" + _vm._s(_vm.formats.blank(_vm.formats.getValue(_vm.item, ['number']))) + ") \n              ")])]
  })], 2), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.certificates != null),
      expression: "item.certificates != null"
    }]
  }, [_vm._v("\n            Свидетельства:\n            "), _vm._l((_vm.item.certificates), function(cert) {
    return [_c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.formats.getValue(cert, ['date']), _vm.formats.formatDate)))]), _vm._v(" - серия: " + _vm._s(_vm.formats.blank(_vm.formats.getValue(cert, ['series']))) + " номер: " + _vm._s(_vm.formats.blank(_vm.formats.getValue(cert, ['number']))) + " \n              ")])]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1d85af8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/LonerRecordForm.vue
// module id = 1115
// module chunks = 1